import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import "./Student_window_hub.css";

/* ============================================================
   IMAGE IMPORTS
============================================================ */
import slider1 from "../assets/silder1.png";
import slider2 from "../assets/slider2.jpg";
import slider3 from "../assets/slider3.png";

/* ============================================================
   SAFE IMAGE
============================================================ */
const safeSrc = (img) => img || "";

/* ============================================================
   SLIDER DATA
============================================================ */
const SLIDERS = [
  {
    src: safeSrc(slider2),
    fallback: "Find Your School",
    title: "Find Your School",
    subtitle: "please enter valid school code",
    tag: "Smart School Search",
  },
  {
    src: safeSrc(slider1),
    fallback: "Student School Darpan",
    title: "Student School Darpan",
    subtitle: "Empowering Education in Rajasthan",
    tag: "Digital Education",
  },
  {
    src: safeSrc(slider3),
    fallback: "Explore Opportunities",
    title: "Explore Opportunities",
    subtitle: "Discover Schemes & Programs",
    tag: "Education Opportunities",
  },
];

/* ============================================================
   CARD ICONS
============================================================ */
const CARD_ICONS = {
  school: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M6 26 32 8l26 18" />
      <path d="M12 26v30h40V26" />
      <rect x="22" y="38" width="8" height="18" />
      <rect x="34" y="38" width="8" height="18" />
      <path d="M28 18h8" />
    </svg>
  ),

  planning: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="8" y="10" width="48" height="44" rx="4" />
      <path d="M8 22h48" />
      <path d="M20 34h20" />
      <path d="M20 42h14" />
      <circle cx="46" cy="34" r="5" />
    </svg>
  ),

  report: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="14" y="8" width="36" height="48" rx="4" />
      <path d="M22 22h20" />
      <path d="M22 30h20" />
      <path d="M22 38h14" />
      <circle cx="32" cy="49" r="2" />
    </svg>
  ),

  team: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="16" r="7" />
      <path d="M18 50a14 14 0 0 1 28 0" />
      <circle cx="10" cy="22" r="5" />
      <path d="M0 48a10 10 0 0 1 20 0" />
      <circle cx="54" cy="22" r="5" />
      <path d="M44 48a10 10 0 0 1 20 0" />
    </svg>
  ),
};

/* ============================================================
   QUICK LINKS
============================================================ */
const CARDS = [
  {
    title: "Search School",
    description: "Find school information",
    icon: CARD_ICONS.school,
    cls: "bg-orange",
    href: "",
  },
  {
    title: "School Reports",
    description: "View school reports",
    icon: CARD_ICONS.planning,
    cls: "bg-violet",
    href: "",
  },
  {
    title: "Student Reports",
    description: "Student information",
    icon: CARD_ICONS.report,
    cls: "bg-yellow",
    href: "",
  },
  {
    title: "Staff Reports",
    description: "Staff information",
    icon: CARD_ICONS.team,
    cls: "bg-blue",
    href: "",
  },
];

/* ============================================================
   MAIN COMPONENT
============================================================ */
export default function Student_window_hub() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imgErrors, setImgErrors] = useState({});
  const [isPaused, setIsPaused] = useState(false);

  const touchStartX = useRef(0);

  /* ============================================================
     NEXT
  ============================================================ */
  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % SLIDERS.length);
  }, []);

  /* ============================================================
     PREVIOUS
  ============================================================ */
  const prevSlide = useCallback(() => {
    setCurrentSlide(
      (prev) => (prev - 1 + SLIDERS.length) % SLIDERS.length
    );
  }, []);

  /* ============================================================
     GO TO
  ============================================================ */
  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  /* ============================================================
     AUTOPLAY
  ============================================================ */
  useEffect(() => {
    if (isPaused) return;

    const timer = setInterval(nextSlide, 5000);

    return () => clearInterval(timer);
  }, [isPaused, nextSlide]);

  /* ============================================================
     KEYBOARD
  ============================================================ */
  useEffect(() => {
    const handleKeyboard = (event) => {
      if (event.key === "ArrowRight") nextSlide();
      if (event.key === "ArrowLeft") prevSlide();
    };

    window.addEventListener("keydown", handleKeyboard);

    return () => {
      window.removeEventListener("keydown", handleKeyboard);
    };
  }, [nextSlide, prevSlide]);

  /* ============================================================
     TOUCH
  ============================================================ */
  const handleTouchStart = (event) => {
    touchStartX.current = event.changedTouches[0].screenX;
  };

  const handleTouchEnd = (event) => {
    const touchEndX = event.changedTouches[0].screenX;
    const difference = touchStartX.current - touchEndX;

    if (Math.abs(difference) > 50) {
      difference > 0 ? nextSlide() : prevSlide();
    }
  };

  /* ============================================================
     IMAGE ERROR
  ============================================================ */
  const handleImageError = (index) => {
    setImgErrors((prev) => ({
      ...prev,
      [index]: true,
    }));
  };

  return (
    <div className="cw-app">

      {/* ======================================================
          HERO
      ====================================================== */}
      <main>

        <section
          id="divbanner"
          className="cw-hero-section"
        >
          <div
            className="hero_banner"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            aria-roledescription="carousel"
            aria-label="Student School Darpan slider"
          >

            {/* Decorative elements */}
            <span className="hero-orb hero-orb-one" />
            <span className="hero-orb hero-orb-two" />

            {/* ==================================================
                SLIDES
            ================================================== */}
            {SLIDERS.map((slide, index) => (
              <article
                key={index}
                className={`hero_slide ${
                  currentSlide === index ? "active" : ""
                }`}
                aria-hidden={currentSlide !== index}
              >

                {slide.src && !imgErrors[index] ? (
                  <img
                    src={slide.src}
                    alt={slide.title}
                    className="hero_img"
                    draggable="false"
                    onError={() => handleImageError(index)}
                  />
                ) : (
                  <div className="hero_fallback">
                    <span>{slide.fallback}</span>
                  </div>
                )}

                <div className="hero-overlay" />

                <div className="hero-content">

                  {/* LEFT CONTENT */}
                  <div className="hero-content-box01">

                    <div className="hero-mini-line">
                      <span />
                      Rajasthan Education Portal
                    </div>

                    <span className="hero-badge">
                      <span className="badge-dot" />
                      {slide.tag}
                    </span>

                    <h1 className="heading-1">
                      {slide.title}
                    </h1>

                    <p className="heading-2">
                      {slide.subtitle}
                    </p>

                    <div className="hero-bottom-info">
                      <span>
                        Student School Darpan
                      </span>

                      <span className="hero-info-line" />

                      <span>
                        Government of Rajasthan
                      </span>
                    </div>

                  </div>
                </div>
              </article>
            ))}

            {/* ==================================================
                PREVIOUS
            ================================================== */}
            <button
              type="button"
              className="slider-arrow slider-arrow-prev"
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              <svg viewBox="0 0 24 24">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </button>

            {/* ==================================================
                NEXT
            ================================================== */}
            <button
              type="button"
              className="slider-arrow slider-arrow-next"
              onClick={nextSlide}
              aria-label="Next slide"
            >
              <svg viewBox="0 0 24 24">
                <path d="M8.59 16.59L10 18l6-6-6-6 1.41 1.41L13.17 12z" />
              </svg>
            </button>

            {/* ==================================================
                DOTS
            ================================================== */}
            <div className="slider_dots">
              {SLIDERS.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={
                    currentSlide === index ? "active" : ""
                  }
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  aria-current={
                    currentSlide === index ? "true" : undefined
                  }
                />
              ))}
            </div>

            {/* ==================================================
                PROGRESS
            ================================================== */}
            <div className="slider-progress">
              <div
                className="slider-progress-bar"
                style={{
                  width: `${
                    ((currentSlide + 1) /
                      SLIDERS.length) *
                    100
                  }%`,
                }}
              />
            </div>

          </div>
        </section>

        {/* ======================================================
            CONTENT
        ====================================================== */}
        <section className="cw-main-content">

          <div className="container">

            <div className="content-wrap">

              {/* BREADCRUMB */}
              <nav
                className="breadcrumb-arrow"
                aria-label="Breadcrumb"
              >
                <Link
                  to="/Student_school_darpan"
                  title="Student School Darpan"
                >
                  <span className="breadcrumb-home">⌂</span>
                  Student School Darpan
                </Link>
              </nav>

              {/* ABOUT */}
              <section className="about">

                <div className="contentArea">

                  <div className="about-decoration">
                    <span />
                    <span />
                    <span />
                  </div>

                  <span className="section-kicker">
                    Rajasthan Education Portal
                  </span>

                  <h2>
                    Student School Darpan
                  </h2>

                  <div className="content-divider">
                    <span />
                  </div>

                  <p>
                    In the present era of information
                    technology, information management is an
                    essential component for the operation and
                    upgradation of any organisation. Student
                    School Darpan is a dynamic database
                    management portal, where information about
                    all government schools and education
                    offices is kept online and updated as a
                    continuous process.
                  </p>

                  <p>
                    In this portal, "live data" is compiled in
                    connection with primary and secondary
                    education students, schools and academic
                    and non-academic staff.
                  </p>

                </div>

              </section>

              {/* QUICK LINKS */}
              <section
                className="link-tab"
                aria-label="Quick Links"
              >

                <div className="section-heading">

                  <span className="heading-label">
                    Quick Access
                  </span>

                  <h2>
                    Explore Student School Darpan
                  </h2>

                  <p>
                    Access school, student and staff
                    information from one place.
                  </p>

                </div>

                <div className="cards-row">

                  {CARDS.map((card, index) => (
                    <div
                      className="card-col"
                      key={card.title}
                      style={{
                        "--card-delay": `${index * 80}ms`,
                      }}
                    >

                      <Link
                        to={card.href}
                        className={`card ${card.cls}`}
                        aria-label={card.title}
                      >

                        <div className="card-glow" />

                        <div className="card-bg">

                          <div className="card-number">
                            0{index + 1}
                          </div>

                          <div className="card-icon">
                            {card.icon}
                          </div>

                          <div className="card-content">

                            <div>
                              <h3>
                                {card.title}
                              </h3>

                              <p>
                                {card.description}
                              </p>
                            </div>

                            <span className="card-arrow">
                              →
                            </span>

                          </div>

                        </div>

                      </Link>

                    </div>
                  ))}

                </div>

              </section>

            </div>

          </div>

        </section>

      </main>
    </div>
  );
}